export default "__VITE_ASSET__CIQx0Td___"